import React from 'react';
import { observer } from 'mobx-react';
import { Box, FormControl, useTheme } from '@mui/material';
import AttachmentsList from '../AttachmentsList';
import { AttachmentQcFieldName } from './const';
import useData from './hook';
import { ValueFieldsTypesProps } from '50.quickConnect.Fields/FieldsTypes/types';
import { BaseAttachmentDesc } from '90.quickConnect.Models/models';
import { FieldMainBox, FlexRow } from '50.quickConnect.Fields/styles';
import QcTooltip from '50.quickConnect.Fields/QcTooltip';

const AttachmentQcField = ({
  field,
  updateDeclaration,
  labelSpan,
  setSelectedIndex,
  isReadOnly,
  labelClass,
}: ValueFieldsTypesProps) => {
  const attachDesc = field as BaseAttachmentDesc;
  const { fieldType, toolTip, id, stateId, fullPathId } = attachDesc;
  const nameWithId = `${AttachmentQcFieldName}-${id}`;
  const { localValue, handleFileDrop, handleFileDelete, handleFilePreview } = useData(
    false,
    attachDesc,
    updateDeclaration,
  );

  const { breakpoints } = useTheme();

  return (
    <Box
      id={`scrollToAnchor-${fullPathId}`}
      className={labelClass}
      data-cy={`${nameWithId}-box`}
      sx={FieldMainBox(breakpoints)}
      onClick={() => (isReadOnly ? undefined : setSelectedIndex(fullPathId))}
    >
      <Box sx={FlexRow}>
        <Box component="span" sx={{ flex: 1 }}>
          {labelSpan}
        </Box>
        {toolTip && <QcTooltip parentId={id} tooltip={toolTip} />}
      </Box>
      <FormControl data-cy={`${nameWithId}-control`} variant="outlined" fullWidth>
        <AttachmentsList
          fieldType={fieldType}
          onlyImage={false}
          parentId={nameWithId}
          attachments={localValue}
          onDrop={handleFileDrop}
          onDelete={handleFileDelete}
          onPreview={handleFilePreview}
          isReadOnly={isReadOnly}
          stateId={stateId}
        />
      </FormControl>
    </Box>
  );
};

export default observer(AttachmentQcField);
